export default function CTASection() {
  return (
    <section className="py-24 bg-gradient-to-r from-gray-900 to-gray-800 text-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl sm:text-5xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
          Ready to Experience the <span className="text-[#C9A961]">Perfect Fit?</span>
        </h2>
        
        <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
          Call for appointment today and discover why discerning clients choose 
          <strong className="text-white"> British Custom Tailors</strong> for their custom clothing needs.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
          <a 
            href="#consultation" 
            className="inline-flex items-center bg-[#C9A961] text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-[#B89851] transition-all duration-300 shadow-2xl hover:shadow-[#C9A961]/50 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-calendar-check-line mr-3 text-xl"></i>
            Call for Appointment
          </a>
          <a 
            href="tel:866-857-8487" 
            className="inline-flex items-center bg-white text-gray-900 px-10 py-5 rounded-full text-lg font-bold hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-phone-line mr-3 text-xl"></i>
            866-857-8487
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
            <i className="ri-home-smile-line text-4xl text-[#C9A961] mb-3"></i>
            <h3 className="font-bold text-lg mb-2">House Calls</h3>
            <p className="text-sm text-gray-300">We come to you nationwide</p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
            <i className="ri-vip-crown-line text-4xl text-[#C9A961] mb-3"></i>
            <h3 className="font-bold text-lg mb-2">Premium Quality</h3>
            <p className="text-sm text-gray-300">Finest fabrics and craftsmanship</p>
          </div>

          <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
            <i className="ri-shield-check-line text-4xl text-[#C9A961] mb-3"></i>
            <h3 className="font-bold text-lg mb-2">Perfect Fit</h3>
            <p className="text-sm text-gray-300">Masterfully Tailored</p>
          </div>
        </div>
      </div>
    </section>
  );
}